module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0089.png.a7766ade.jpg";